import { Component, Input } from '@angular/core';
import { Projection } from '../models';
import { FormatDatePipe } from 'src/app/miscellaneous/pipes/format-date.pipe';

@Component({
  selector: 'app-bobby-calves-approved-card',
  templateUrl: './bobby-calves-approved-card.component.html',
  styleUrls: ['./bobby-calves-approved-card.component.scss'],
})
export class BobbyCalvesApprovedCardComponent {
  @Input() pickup: Projection.Pickup;

  constructor(private readonly dateFormatter: FormatDatePipe) {}

  public get date(): string {
    return this.dateFormatter.transform(this.pickup.date, 'dwdm');
  }
}
